module.exports = __webpack_public_path__ + "static/tinderstrike-02b156c0a12750d8c8748ca0af5cbd11.png";